<template>
    <div class="fac-image" :class="design">
        <ui-popover v-if="setPopover" :arrow-popover="arrowPopover" trigger="hover">
            <template #target>
                <img :src="image" :alt="alt" :height="h" :width="w" :class="{'cover': cover, 'contain': contain, 'fill': fill, 'scale-down': scaleDown, 'none': none}"/>
            </template>
            <template v-if="hasPopover" #content>
                <slot name="popover"/>
            </template>
        </ui-popover>
        <div v-else>
            <img :src="image" :alt="alt" :height="h" :width="w" :class="{'cover': cover, 'contain': contain, 'fill': fill, 'scale-down': scaleDown, 'none': none}"/>
        </div>
    </div>
</template>
<script>
	import userImage from '@/assets/imgs/no-avatar.png'

	export default {
		name: 'ui-image',
		components: {
			uiPopover: () => import('@/components/ui/popover/index.vue'),
		},
		props: {
			src: {
				type: String,
				required: false,
			},
			defaultSrc: {
				type: String,
				required: false,
				default: userImage,
			},
			alt: {
				type: String,
				required: false,
				default: 'image',
			},
			design: {
				type: String,
				required: false,
			},
			h: {
				type: String,
				required: false,
			},
			w: {
				type: String,
				required: false,
				default: 'auto',
			},
			fill: {
				type: Boolean,
				default: false
			},
			contain: {
				type: Boolean,
				default: false
			},
			cover: {
				type: Boolean,
				default: true
			},
			scaleDown: {
				type: Boolean,
				default: false
			},
			none: {
				type: Boolean,
				default: false
			},
			arrowPopover: {
				type: Boolean,
				default: true
			},
			setPopover: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				image: '',
			}
		},

		computed: {
			imageSRC() {
				return this.src
			},
			hasPopover() {
				return this.$slots['popover'] ? true : false
			},
		},

		mounted() {
			this.image = this.defaultSrc
			this.checkImage()
		},

		methods: {
			checkImage() {
				let img = new Image()
				img.onload = () => {
					this.image = this.src
				}

				img.src = this.src
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
